export default {
      id: "icon--facebook-usage",
      viewBox: "0 0 13.77 26",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--facebook-usage",
      toString: function () {
        return this.url;
      }
    }